// Libraries
import React from "react"
import PropTypes from "prop-types"
import domUtil from "lib/dom/dom-util"

// Styles
import "./Overlay.scss"

function Overlay({ isCsAgent }) {
  if (isCsAgent) {
    const asmBanner = domUtil.findFirst("#asmBanner")
    const overlayTopStyle = {
      top: asmBanner ? asmBanner.offsetHeight + 100 : "auto",
    }

    return <div style={overlayTopStyle} className="Overlay" />
  }

  const promoStrip = domUtil.findFirst(".persistent-promo")
  const overlayTopStyle = {
    top: promoStrip ? promoStrip.offsetHeight + 100 : "auto",
  }
  return <div style={overlayTopStyle} className="Overlay" />
}
export default Overlay

Overlay.propTypes = {
  isCsAgent: PropTypes.bool,
}
